import {max, min} from 'ramda';

import {ChartVariant} from '../types/ChartVariant';
import {ExtendedStatisticsCar} from '../types/ExtendedStatisticsCar';
import {getChartCoordinates} from './getChartCoordinates';

export const getYsForStackedBar = (
  car: ExtendedStatisticsCar,
  myVehicle: ExtendedStatisticsCar,
  chartVariant: ChartVariant
) => {
  const coordinates = getChartCoordinates(car, chartVariant);
  const myVehicleCoordinates = getChartCoordinates(myVehicle, chartVariant);
  const y1 = min(myVehicleCoordinates.y, coordinates.y);
  const y2 = max(myVehicleCoordinates.y, coordinates.y) - y1;

  return {y1, y2};
};
